$(document).ready(function() {
  var timeout = null;

  reloadCheckoutPage(timeout);
  const callreloadCheckoutPage = () => reloadCheckoutPage(timeout);
  window.callreloadCheckoutPage = callreloadCheckoutPage;

  // Initialize shipping fee calculation if shipping is allowed
  initShippingFeeCalculation();
});

function reloadCheckoutPage(timeout){
  window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted || 
                          ( typeof window.performance != "undefined" && 
                                window.performance.navigation.type === 2 );

    const d = new Date();
    let time = d.getTime();

    var startDate = new Date(time * 1000);
    var endDate   = new Date();
    var seconds = (endDate.getTime() - startDate.getTime());
    var expired = seconds > 1000 * 60 * 3; // 3 minutes

    if ( historyTraversal && expired ) {
      // Handle page reload.
      window.location.reload();
    }
  });
}

function initShippingFeeCalculation() {
  var $checkoutContainer = $('.row.checkout');
  var allowShipping = $checkoutContainer.data('allow-shipping') === true || $checkoutContainer.data('allow-shipping') === 'true';

  if (!allowShipping) {
    return;
  }

  var shipFeeUrl = $checkoutContainer.data('ship-fee-url');
  var shippingFeeLabel = $checkoutContainer.data('shipping-fee-label');
  var taxAmountLabel = $checkoutContainer.data('tax-amount-label');

  // Calculate shipping fee for initially selected address (silently, no alerts)
  // Check if checkbox exists and is checked before calculating
  var initialAddress = $(".order-address-list input[type=radio]:checked");
  if (initialAddress.length > 0 && !$("input[name='self_collection']").is(":checked")) {
    var addressId = initialAddress.val();
    // Use a small delay to ensure checkbox state is set if it's set programmatically
    setTimeout(function() {
      updateShippingFee(addressId, shipFeeUrl, false); // false = don't show alerts on page load
    }, 50);
  }

  // Function to enable/disable place order button based on shipping validation
  function updatePlaceOrderButtonState() {
    var $placeOrderBtn = $('#btn-place-order');
    if (!allowShipping) {
      $placeOrderBtn.prop('disabled', false);
      return;
    }

    var selfCollection = $("input[name='self_collection']").is(":checked");
    var addressSelected = $(".order-address-list input[type=radio]:checked").length > 0;

    if (selfCollection || addressSelected) {
      $placeOrderBtn.prop('disabled', false);
    } else {
      $placeOrderBtn.prop('disabled', true);
    }
  }

  // Initialize button state on page load
  updatePlaceOrderButtonState();

  // Handle self collection checkbox change
  $("input[name='self_collection']").change(function() {
    if ($(this).is(":checked")) {
      $(".order-address-list input[type=radio]:checked").prop('checked', false);
      updateShippingFee(null, shipFeeUrl, true); // Show alerts when user checks self collection
    }
    updatePlaceOrderButtonState();
  });

  // Handle address radio button change
  $(".order-address-list input[type=radio]").change(function() {
    if ($(this).is(":checked")) {
      $("input[name='self_collection']").prop('checked', false);
      var addressId = $(this).val();
      updateShippingFee(addressId, shipFeeUrl, true); // true = show alerts when user selects address
    }
    updatePlaceOrderButtonState();
  });

  // Handle clicks on the address card itself
  $(".mailing__card").click(function(e) {
    // Don't trigger if clicking directly on the radio button (it will trigger its own change event)
    if ($(e.target).is('input[type=radio]')) {
      return;
    }

    var radioButton = $(this).find('input[type=radio]');
    if (radioButton.length > 0) {
      radioButton.prop('checked', true);
      $("input[name='self_collection']").prop('checked', false);
      var addressId = radioButton.val();
      updateShippingFee(addressId, shipFeeUrl, true); // true = show alerts when user clicks address card
      updatePlaceOrderButtonState();
    }
  });

  $(".order-address-list").click(function(){
    $("input[name='self_collection']").prop('checked', false);
    updatePlaceOrderButtonState();
  });

  function updateShippingFee(addressId, url, showAlerts) {
    // showAlerts defaults to true if not specified (for backward compatibility)
    showAlerts = showAlerts !== false;

    var allowShipping = true; // Already checked in initShippingFeeCalculation
    var selfCollection = $("input[name='self_collection']").is(":checked");
    var useBalance = $('#use_balance').is(':checked');
    var cartItemIds = [];
    $("input[name='checkout[cart_item_ids][]']").each(function() {
      cartItemIds.push($(this).val());
    });

    // Always call backend to get accurate totals (handles all cases: address, self-collection, no shipping)
    // If self-collection or no address, pass null for address_id
    var requestAddressId = (!allowShipping || selfCollection || !addressId) ? null : addressId;

    $.ajax({
      url: url,
      method: 'POST',
      data: {
        address_id: requestAddressId,
        cart_item_ids: cartItemIds,
        use_balance: useBalance,
        self_collection: selfCollection,
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        // Show error alert if present, but still update billing details
        if (response.error && showAlerts) {
          alert(response.error);
        }
        // Always update billing details with backend-calculated values
        updateBillingDetails(response, shippingFeeLabel, taxAmountLabel, useBalance);
      },
      error: function(xhr) {
        var errorMsg = 'Failed to calculate totals';
        var response = null;

        // Check if backend returned error with billing details (status 400 but with JSON response)
        if (xhr.responseJSON) {
          response = xhr.responseJSON;
          if (response.error) {
            errorMsg = response.error;
          }
          // If backend included billing details in error response, use them
          if (response.total !== undefined) {
            if (showAlerts) {
              alert(errorMsg);
            }
            updateBillingDetails(response, shippingFeeLabel, taxAmountLabel, useBalance);
            return;
          }
        }

        // If no billing details in error response, show error and try to preserve current values
        if (showAlerts) {
          alert(errorMsg);
        }
        // Try to preserve current displayed values (fallback)
        var currentSubtotal = parseFloat($('.total-payment tbody tr').eq(0).find('td.text-right strong').text().replace(/[^\d.-]/g, '')) || 0;
        var currentTax = parseFloat($('.total-payment tbody tr').eq(1).find('td.text-right strong').text().replace(/[^\d.-]/g, '')) || 0;
        var currentShipFee = 0;
        var shipFeeRow = $('#shipping_fee_row');
        if (shipFeeRow.length > 0 && shipFeeRow.is(':visible')) {
          currentShipFee = parseFloat($('#ship_fee_amount').text().replace(/[^\d.-]/g, '')) || 0;
        }
        var currentEWallet = 0;
        var eWalletRow = $('.order_use-balance');
        if (eWalletRow.length > 0 && eWalletRow.is(':visible') && useBalance) {
          currentEWallet = parseFloat(eWalletRow.data('current-mutation')) || 0;
        }
        var calculatedTotal = currentSubtotal + currentTax + currentShipFee - currentEWallet;
        if (calculatedTotal < 0) calculatedTotal = 0;

        updateBillingDetails({
          ship_fee: currentShipFee,
          subtotal_items: currentSubtotal,
          total_tax_amount: currentTax,
          total: calculatedTotal,
          current_ewallet_amount: currentEWallet,
          allow_use_tqg_ewallet: useBalance && currentEWallet > 0
        }, shippingFeeLabel, taxAmountLabel, useBalance);
      }
    });
  }

  function updateBillingDetails(response, shippingFeeLabel, taxAmountLabel, useBalance) {
    // Update shipping fee display
    var shipFee = response.ship_fee || 0;
    var shipFeeRow = $('#shipping_fee_row');

    if (shipFee > 0) {
      if (shipFeeRow.length === 0) {
        // Insert shipping fee row after tax amount row if it doesn't exist
        var taxRow = $('tr:has(td:contains("' + taxAmountLabel + '"))');
        var newRow = '<tr id="shipping_fee_row"><td class="payment-title pl-0">' + shippingFeeLabel + '</td><td class="text-right text-dark"><strong id="ship_fee_amount">' + formatMoney(shipFee) + '</strong></td></tr>';
        taxRow.after(newRow);
      } else {
        $('#ship_fee_amount').text(formatMoney(shipFee));
        shipFeeRow.show();
      }
    } else {
      if (shipFeeRow.length > 0) {
        shipFeeRow.hide();
      }
    }

    // Update e-wallet row visibility and data
    var eWalletRow = $('.order_use-balance');
    if (eWalletRow.length > 0 && response.current_ewallet_amount) {
      if (useBalance && response.allow_use_tqg_ewallet) {
        eWalletRow.removeClass('d-none');
        eWalletRow.find('td.text-right strong').text('- ' + formatMoney(response.current_ewallet_amount));
        // Update data attributes for future reference
        eWalletRow.data('current-mutation', response.current_ewallet_amount);
      } else {
        eWalletRow.addClass('d-none');
      }
    }

    // Update total using backend-calculated value
    if (response.total !== undefined) {
      $('.grand_total_amount strong').text(formatMoney(response.total));
    }
  }

  function formatMoney(amount) {
    return 'RM ' + parseFloat(amount).toFixed(2);
  }

  // Handle use_balance checkbox change - recalculate totals from backend
  // We need to attach this handler AFTER custom_user.js runs, so we use setTimeout
  // Also remove the old handler from custom_user.js that uses client-side calculation
  setTimeout(function() {
    // Remove all existing handlers (including from custom_user.js)
    $('#use_balance').off('change');

    // Attach our handler that uses backend calculation
    $('#use_balance').on('change.checkout', function(e) {
      // Prevent other handlers from running
      e.stopImmediatePropagation();

      var useBalance = $(this).is(':checked');
      var eWalletRow = $('.order_use-balance');

      // Toggle visibility immediately for better UX
      if (useBalance) {
        eWalletRow.removeClass('d-none');
      } else {
        eWalletRow.addClass('d-none');
      }

      // Recalculate totals from backend with updated use_balance state
      var selfCollection = $("input[name='self_collection']").is(":checked");
      var selectedAddress = $(".order-address-list input[type=radio]:checked");
      var addressId = selectedAddress.length > 0 ? selectedAddress.val() : null;

      if (!allowShipping || selfCollection || !addressId) {
        // For self-collection or no shipping, we still need to recalculate with e-wallet
        // Get current values and recalculate
        var cartItemIds = [];
        $("input[name='checkout[cart_item_ids][]']").each(function() {
          cartItemIds.push($(this).val());
        });

        $.ajax({
          url: shipFeeUrl,
          method: 'POST',
          data: {
            address_id: null,
            cart_item_ids: cartItemIds,
            use_balance: useBalance,
            self_collection: selfCollection,
            authenticity_token: $('meta[name="csrf-token"]').attr('content')
          },
          success: function(response) {
            updateBillingDetails(response, shippingFeeLabel, taxAmountLabel, useBalance);
          }
        });
      } else {
        // Recalculate with current address
        updateShippingFee(addressId, shipFeeUrl, false);
      }
    });
  }, 100);

  // Validate shipping address selection before form submission
  $('#form-place-order').submit(function(e) {
    if (!allowShipping) {
      return true; // No validation needed if shipping is not allowed
    }

    var selfCollection = $("input[name='self_collection']").is(":checked");
    var addressSelected = $(".order-address-list input[type=radio]:checked").length > 0;

    if (!selfCollection && !addressSelected) {
      e.preventDefault();
      alert('Please select a delivery address or choose self collection');
      return false;
    }

    // Validate address completeness and shipping availability if address is selected
    if (!selfCollection && addressSelected) {
      var selectedAddressId = $(".order-address-list input[type=radio]:checked").val();
      var addressCard = $(".order-address-list input[type=radio][value='" + selectedAddressId + "']").closest('.mailing__card');
      var validationFailed = false;
      var errorMessage = '';

      // Check address completeness and shipping availability via AJAX
      $.ajax({
        url: shipFeeUrl,
        method: 'POST',
        async: false,
        data: {
          address_id: selectedAddressId,
          cart_item_ids: $("input[name='checkout[cart_item_ids][]']").map(function() { return $(this).val(); }).get(),
          authenticity_token: $('meta[name="csrf-token"]').attr('content'),
          validate_only: true
        },
        success: function(response) {
          // Check if response contains an error (even in success response)
          if (response.error) {
            validationFailed = true;
            errorMessage = response.error;
          }
        },
        error: function(xhr) {
          if (xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.error) {
            validationFailed = true;
            errorMessage = xhr.responseJSON.error;
          }
        }
      });

      // Block order placement if validation failed
      if (validationFailed && errorMessage) {
        e.preventDefault();
        alert(errorMessage);
        return false;
      }
    }

    return true;
  });

  // Make updateShippingFee available globally if needed
  window.updateShippingFee = function(addressId) {
    updateShippingFee(addressId, shipFeeUrl, true); // Show alerts when called globally
  };
}
